import { c as _c } from "react/compiler-runtime";
import styles from './last-updated.module.scss';
import classNames from 'classnames';
import { Icon } from '@udemy-v2/icons';
import { useFormatDate, useI18n } from '@udemy-v2/i18n';
import { useClpCourse } from '../../context/clp-course-provider.react-component';

/**
 * Component that displays when a course was last updated
 * Shows a calendar icon with "Last updated <date>" text
 */
export const LastUpdated = () => {
  const $ = _c(8);
  const course = useClpCourse();
  const {
    toLocaleDateString
  } = useFormatDate();
  const {
    gettext,
    interpolate
  } = useI18n();
  if (!course.updatedOn) {
    return null;
  }
  let t0;
  if ($[0] !== course.updatedOn || $[1] !== gettext || $[2] !== interpolate || $[3] !== toLocaleDateString) {
    const dateObj = new Date(course.updatedOn);
    const formattedDate = toLocaleDateString(dateObj, {
      year: "numeric",
      month: "numeric",
      timeZone: "UTC"
    });
    t0 = interpolate(gettext("Last updated %(date)s"), {
      date: formattedDate
    }, true);
    $[0] = course.updatedOn;
    $[1] = gettext;
    $[2] = interpolate;
    $[3] = toLocaleDateString;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const lastUpdatedText = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles["last-updated"], "ud-text-sm");
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== lastUpdatedText) {
    t2 = <div className={t1}><Icon glyph="calendar-30" size="xsmall" label={lastUpdatedText} /><span>{lastUpdatedText}</span></div>;
    $[6] = lastUpdatedText;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};